import AttachFileRounded from '@mui/icons-material/AttachFileRounded';
import { Box } from '@mui/material';

/** The paper-clip shown next to a list row that has files attached. */
export function Paperclip({ count }: { count: number | undefined }) {
  if (!count) return null;
  const label = count === 1 ? '1 file attached' : `${String(count)} files attached`;
  return (
    <Box
      component="span"
      title={label}
      aria-label={label}
      role="img"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'text.secondary',
        ml: 0.5,
        verticalAlign: 'middle',
        fontSize: '0.75rem',
      }}
    >
      <AttachFileRounded sx={{ fontSize: '1rem', transform: 'rotate(45deg)' }} />
      {count > 1 && count}
    </Box>
  );
}
